// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#kontakt[data-v-b21cd09e]{align-items:center;display:flex;height:80%}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Kontakt.vue"],"names":[],"mappings":"AAAA,0BAAiC,kBAAA,CAAb,YAAA,CAAX,UAIT","sourcesContent":["#kontakt{height:80%;display:flex;align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
